
import { mapState } from 'vuex'

export default {
  name: 'ProductModifier',

  props: {
    activeModifier: {
      type: Number,
      default: 0
    },
    tab: {
      type: Number,
      default: 0
    },
    modifiers: {
      type: Array,
      default: () => []
    },
    onAddModifier: {
      type: Function,
      default: () => {}
    },
    setActiveMod: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      selectedId: '',
      toggled: true,
      lastActiveGroup: null,
      addingModifier: false
    }
  },
  created() {
    this.selectedId = this.modifiers[0].id
    this.lastActiveGroup = this.modifiers[0].id
    this.toggled = true
  },
  computed: {
    mobile() {
      return (this.$mq == 'sm' || this.$mq == 'md')
    }
  },
  methods: {
    description(name) {
      if (name.split('(')[1]) {
        name = name.split('(')[1]
        name = name.replace(')', '').trim()
        return name.charAt(0).toUpperCase() + name.slice(1)
      }
    },
    hasImages(m) {
      return m.options?.some(o =>
        o.metadata?.some(item => item.key === 'modifier-image' && item.value)
      ) || false
    },
    totalOptionsSelected(o) {
      const seleted = o.map((m) => {
        return m.selected || 0
      })

      return seleted.reduce((ac, next) => ac + next, 0)
    },
    selectedOption(opt) {
      const option = opt.find((f) => f.selected)
      return option ? option.name : 0
    },
    maxSelected(m) {
      let selected = 0
      if (m.options) {
        m.options.forEach(option => {
          if (option.selected) {
            selected += option.selected
          }
        })
      }
      if (selected == m.selects.max) {
        return true
      } else {
        return false
      }
    },
    toggleModOption(m, o) {
      this.addModifier(m.id, o.id)
      o.selected = !o.selected
    },
    async addModifier(mid, oid, q = 1) {
      await this.onAddModifier(mid, oid, q)

      // If max options are selected or max is not set scroll to the next modifier
      let selected = 0
      let max = 0
      this.modifiers.forEach(m => {
        if (mid == m.id) {
          max = m.selects.max
          m.options.forEach(o => {
            const counter = !(m.selects.min == null && m.selects.max == null) && m.selects.min >= 0 && m.selects.max >= 0
            if (o.selected) {
              if (counter) {
                selected += o.selected
              } else {
                selected += 1
              }
            }
          })
          return
        }
      })
      const toggles = [...document.querySelectorAll('.mod-toggle')].sort((a, b) => (a.getBoundingClientRect().top - b.getBoundingClientRect().top))
      const toggle = document.activeElement?.closest('.mod-option')?.parentNode?.previousElementSibling
      let nextMod = null
      toggles.forEach((mod, i) => {
        if (toggle == mod) {
          nextMod = toggles[i+1]
        }
      })
      if (nextMod) {
        if ((max > 0 && selected == max) || max == null) {
          const offset = document.querySelector('header').getBoundingClientRect().height-1
          if (this.mobile) {
            const top = nextMod.getBoundingClientRect().top + window.scrollY - offset
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          } else {
            const options = document.querySelector('.options')
            const top = nextMod.getBoundingClientRect().top + options.scrollTop - offset
            options.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          }
        }
      }
    },
    setModifierGroup(m) {
      if (m.name) {
        if (m.name.toLowerCase().includes('condiments') || m.name.toLowerCase().includes('sauce')) {
          this.toggled = !this.toggled
        }
      }
      const el = document.activeElement
      if (el && el.classList.contains('mod-toggle')) {
        setTimeout(() => {
          this.selectedId = m.id
          this.setActiveMod(m.id)
          const offset = document.querySelector('header').getBoundingClientRect().height-1
          if (this.mobile) {
            const top = el.getBoundingClientRect().top + window.scrollY - offset
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          } else {
            const options = document.querySelector('.options')
            const top = el.getBoundingClientRect().top + options.scrollTop - offset
            options.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          }
        },250)
      }
    },
    selectedText(m) {
      let counter = false
      if (!(m.selects.min == null && m.selects.max == null) && m.selects.min >= 0 && m.selects.max >= 0) {
        counter = true
      }
      if (counter && m.selects.max) {
        let selected = 0
        m.options.forEach(option => {
          if (option.selected) {
            if (counter) {
              selected += option.selected
            } else {
              selected += 1
            }
          }
        })
        if (selected == 0 && m.selects.min) {
          return 'Select '+m.selects.min
        } else if (selected > 0 && m.selects.min) {
          return selected+' of '+m.selects.max+' selected'
        } else if (m.selects.max) {
          return 'Select up to '+m.selects.max
        }
      }
    },
    modifierSelected(m) {
      // First determine if the mod is a counter
      let counter = false
      if (!(m.selects.min == null && m.selects.max == null) && m.selects.min >= 0 && m.selects.max >= 0) {
        counter = true
      }
      // Next build the text for the toggle
      let selected = []
      m.options.forEach(option => {
        if (option.selected) {
          if (counter) {
            selected.push('('+option.selected+') '+option.name)
          } else {
            selected.push(option.name)
          }
        }
      })
      let text = 'Selected: '
      if (selected.length) {
        selected.forEach((option, i) => {
          if (i == selected.length-1) {
            text += selected[i]
          } else {
            text += selected[i]+', '
          }
        })
      } else {
        return false
      }
      return text
    },
    getModImage(metadata) {
      const url = metadata?.find(item => item.key === 'modifier-image')?.value
      if (!url) return false
      if (!url.includes('storyblok')) return url

      let imageUrl = url
        .replace(/pleinaircdn\.com\/storyblok\//g, 'storyblok.pleinaircdn.com/')
        .replace(/a\.storyblok\.com/g, 'storyblok.pleinaircdn.com')

      const isSvg = imageUrl.split('?')[0].toLowerCase().endsWith('.svg')
      if (!isSvg && !imageUrl.includes('/m/')) {
        imageUrl += '/m/360x0'
      }

      return imageUrl
    }
  }
}
